import { DialogsService } from './../../../services/dialogs-service';
import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import {
  PATH_DETALLE_USUARIO_AGRO,
  PATH_EDITAR_USUARIO_AGRO
} from '../../../navigation/navigation.module';
import { CuentasService } from '../../../services/cuentas-service';
import { FilterType, FilterSettings } from '../../common/dialog/generic-filter-dialog';
import {GenericTableDataSource, GenericTableDialogComponent} from '../../common/dialog/generic-table-dialog';
import {ChipFilterItem} from '../../common/chip-filter-list';
import { SpinnerService } from '../../../services';
import { UsuarioAgroHistorialComponent } from './usuario-agro-historial';
import {Subscription} from 'rxjs/Subscription';
import * as moment from 'moment';
import {MdSnackBar} from '@angular/material';
import {UsuarioAgroPendientesComponent} from './usuario-agro-pendientes';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})export class UsuariosComponent implements OnInit {
  @ViewChild(UsuarioAgroHistorialComponent) historialComponent: UsuarioAgroHistorialComponent;
  @ViewChild(UsuarioAgroPendientesComponent) pendientesComponent: UsuarioAgroPendientesComponent;


  viewIndex = 0;

  agroLoaded = false;

  filtersOpened = false;

  filterChips: ChipFilterItem[] = [];

  tabsLoaded = [false, false]

  @ViewChild(UsuarioAgroHistorialComponent) usuarioHistorialComponent: UsuarioAgroHistorialComponent;

  constructor( ) {
    if (sessionStorage.getItem('currentAgroView')) {
      this.viewIndex = Number(sessionStorage.getItem('currentAgroView'));
    } else {
      this.viewIndex = 0;
      sessionStorage.setItem('currentAgroView', this.viewIndex.toString());
    }
    this.tabsLoaded[this.viewIndex] = true;
  }

  ngOnInit() { }

  loadChips(): void {
    // dado que es posible que intentemos ir a la pagina del historial sin que antes se haya cargado, validamos la variable
    if (this.viewIndex === 0) {
      this.filterChips = this.pendientesComponent ? this.pendientesComponent.pendientesChips.slice() : [];
    } else {
      this.filterChips = this.historialComponent ? this.historialComponent.historialChips.slice() : [];
    }
  }

  resetFilters(): void {
    this.viewIndex === 0 ? this.pendientesComponent.resetFilters() : this.historialComponent.resetFilters();
  }

  removeFilter(chip: ChipFilterItem): void {
    this.viewIndex === 0 ? this.pendientesComponent.removeFilter(chip) : this.historialComponent.removeFilter(chip);
  }

  toggleView(index: number, e = null): void {
    if (e) { e.stopPropagation(); }
    this.viewIndex = index;
    sessionStorage.setItem('currentAgroView', this.viewIndex.toString());
    // verificamos si ya existe el historial para el reload
    if (this.tabsLoaded[1]) {
      this.usuarioHistorialComponent.onViewEnter();
    }
    if (!this.tabsLoaded[this.viewIndex]) {
      this.tabsLoaded[this.viewIndex] = true;
    }
    this.loadChips();
  }

  applyFilters(): void {

  }

  onHistorialReload(): void {
    if (this.tabsLoaded[1]) {
      this.usuarioHistorialComponent.reloadList = true;
    }
  }

}

export interface UsuarioAgro {
  Actual: boolean;
  Mail: string | null;
  Nombre: string;
  Apellido: string;
  Cuits: CuitRazonSoc[];
  Acopios: RolAgenda[];
  Estado: string | null;
  FechaMovimiento: Date;
  FechaValidacion: Date | null;
  ID: number;
  IdEstado: number;
  Observaciones: string | null;
  User: string;
  Telefono: number;
  Roles: RolAgro[];
  OficialesDeCuenta: {Nombre: string, Id: number}[] | null;
  UsuarioValidador: {Nombre: string, Id: number} | null;
  Total: number;
}

export interface RolAgro {
  Nombre: string;
  Id: number;
}

export interface CuitRazonSoc {
  Cuit: number;
  RazonSocial: string;
  AsociadoAgripago: boolean;
}

export interface RolAgenda {
  RolName: string;
  Id: number;
}

export interface TableColumnData {
  column: string;
  title: string;
  width: string;
  order: boolean | null;
  filter: object | null;
  filterType: string;
  filterPropertyName: string;
  sortable: boolean;
}

export function BuildUsuarioAgroChips(data: TableColumnData[]): ChipFilterItem[] {
  const filterChips: ChipFilterItem[] = [];
  data.forEach(x => {
    if (x.filter !== null) {
      let label = '';
      switch (x.filterType) {
        case FilterType.string:
          label = `${x.title} / ${x.filter['MinValue']}`;
          break;
        case FilterType.colaborador:
        case FilterType.acopio:
          label = `${x.title} / ${x.filter['MinValue'].length > 1 ? 'Varios' : x.filter['MinValue'][0].ItemLabel}`;
          break;
        case FilterType.dateRange:
          label = `${x.title} / ${moment.unix(x.filter['MinValue']).format('DD/MM/YYYY')} - ${moment.unix(x.filter['MaxValue']).format('DD/MM/YYYY')}`;
          break;
        case FilterType.chip:
          label = `${x.title} / ${x.filter['MinValue'].length > 1 ? 'Varios' : x.filter['MaxValue'][0]}`;
          break;
        case FilterType.cuitRazon:
          // encaso de haber filtro y razon, armamos uno compuesto, encaso de haber solo uno, los colocamos sumandolos para que se vea solo 1 (pues el otro no existe)
          const second = x.filter['MinValue'] && x.filter['MaxValue'] ? x.filter['MaxValue'] + ' - ' + x.filter['MinValue'] :
            ((x.filter['MinValue'] ? x.filter['MinValue'] : '') + (x.filter['MaxValue'] ? x.filter['MaxValue'].toString() : ''));
          label = `${x.title} / ${second}`;
          break;
        case FilterType.rol:
          label = `${x.title} / ${x.filter['MaxValue'].length > 1 ? 'Varios' : x.filter['MaxValue'][0]}`;
          break;
        case FilterType.singleSelect:
          label = `${x.title} / ${x.filter['MaxValue']}`;
          break;
      }
      filterChips.push({Label: label, Id: x.column});
    }
  });
  return filterChips;
}

export function GetAgroFilterFromColumns(data: TableColumnData[]): object {
  const payload = {}
  data.forEach(col => {
    if (col.filter !== null) {
      switch (col.filterType) {
        case FilterType.dateRange:
          payload[col.filterPropertyName] = {Desde: col.filter['MinValue'], Hasta: col.filter['MaxValue']};
          break;
        case FilterType.acopio:
        case FilterType.colaborador:
          payload[col.filterPropertyName] = col.filter['MinValue'].map(x => x.ID);
          break;
        case FilterType.cuitRazon:
          if (col.filter['MinValue']) {
            payload['RazonSocial'] = col.filter['MinValue'];
          }
          if (col.filter['MaxValue']) {
            // ejecutamos el replace para quitar los caracteres NO numericos
            payload['Cuit'] = col.filter['MaxValue'].replace(/\D/g,'');
          }
          break;
        default:
          payload[col.filterPropertyName] = col.filter['MinValue'];
          break;
      }
    }
  });
  return payload;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/usuarios/usuarios.component.ts